export type ImageAttributeSelection = Record<string, number[]>

export function serializeImageAttributeFilters(selection: ImageAttributeSelection) {
  const constraints = Object.entries(selection)
    .filter(([, values]) => values.length > 0)
    .sort(([a], [b]) => a.localeCompare(b))
    .map(([key, values]) => {
      if (!key.trim() || !values.every(Number.isSafeInteger)) {
        throw new Error('Invalid image attribute filter')
      }
      return { key, values: [...new Set(values)].sort((a, b) => a - b) }
    })
  if (!constraints.length) return undefined
  const serialized = JSON.stringify(constraints)
  if (new TextEncoder().encode(serialized).length > 512) {
    throw new Error('Image attribute filters exceed 512 bytes')
  }
  return serialized
}
